import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Text } from "@pentabd/ui";

import { InputTextRow } from "@components";
import { SelectControllerRow } from "@components/SelectControllerRow";

import { useBaseData } from "@hooks/useBaseData";
import { useLanguage } from "@hooks/useLanguage";

import {
  getConvertedGradeData,
  getConvertedPositionData,
} from "@helpers/baseDataConvert";

import { BASE_DATA } from "@constants/base-data";

import {
  CURRENT_POSITION,
  InitiatePromotionFormValidationDataType,
} from "@validations/HRM/promotion/initiatePromotionFormValidation";

const { DESIGNATIONS, GRADES } = BASE_DATA;

export const CurrentPosition = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  const { data: designations } = useBaseData(DESIGNATIONS);
  const { data: grades } = useBaseData(GRADES);

  const {
    register,
    setValue,
    control,
    formState: { errors },
  } = useFormContext<InitiatePromotionFormValidationDataType>();

  return (
    <>
      <Text
        weight="semibold"
        color="title"
        size="md"
        component="p"
        className="border-bottom pb-8"
      >
        {t("INITIATE_PROMOTION.FORM.POSITION.CURRENT.LABEL")}
      </Text>
      <div className="d-flex flex-column gap-6 py-10">
        <SelectControllerRow
          label="INITIATE_PROMOTION.FORM.POSITION.CURRENT.POSITION"
          name={CURRENT_POSITION.POSITION}
          register={{ ...register(CURRENT_POSITION.POSITION) }}
          options={getConvertedPositionData(designations, language)}
          setValue={setValue}
          control={control}
          disabled
        />
        <InputTextRow
          label="INITIATE_PROMOTION.FORM.POSITION.CURRENT.POSTING"
          register={{ ...register(CURRENT_POSITION.POSTING) }}
          error={errors as any}
          disabled
        />
        <SelectControllerRow
          label="INITIATE_PROMOTION.FORM.POSITION.CURRENT.GRADE"
          name={CURRENT_POSITION.GRADE}
          register={{ ...register(CURRENT_POSITION.GRADE) }}
          options={getConvertedGradeData(grades, language)}
          setValue={setValue}
          control={control}
          disabled
        />
      </div>
    </>
  );
};
